export enum InvolvedVehicleType {
  FourWheelsWithEngine='four-wheels-with-engine',
  TwoWheelsWithEngine='two-wheels-with-engine',
  TwoWheelsWithNoEngine='two-wheels-no-engine',
  None= 'none'
}
